@if (!events || events?.length === 0) {
  <app-loading-and-no-data-template
    [isLoading]="!events"
  ></app-loading-and-no-data-template>
} @else {
  @if (isProcessUnassigning) {
    <div class="unassigning-process-modal">
      {{ 'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.UNASSIGN_PROCESS_WAITING_TEXT' | translate }}
      <i class="far fa-spinner fa-spin"></i>
    </div>
  }
  <div class="table-container pb-4">
    <table mat-table
      matSort
      [dataSource]="dataSource"
      multiTemplateDataRows
      [ngClass]="{'opacity': isProcessUnassigning}"
      class="w-100 overflow-hidden"
      (matSortChange)="sortData($event)">
      @for (column of columnsToDisplay; track column; let i = $index) {
        <ng-container matColumnDef="{{column}}">
          <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column"> {{columnsToTranslate[i] | translate}} </th>
          <td mat-cell *matCellDef="let element; let isLastRow = last">
            @if (i === 0) {
              <div class="item-cell">
                {{element[column]}}
              </div>
            }
            @if (i === 1) {
              <div class="item-cell">
                {{element[column] | uppercase}}
              </div>
            }
            @if (i === 2) {
              <div class="item-cell">
                {{element[column]}}
              </div>
            }
            @if (i === 3) {
              <div class="item-cell">
                <div class="category d-flex align-items-center pl-2 h-100"
                  [ngStyle]="{'border-left-color': element.category | planingEventCategoryColor | async }">
                  {{ ('PLANNING.OVERVIEW.' + element[column].toUpperCase().split(' ')[0]) | translate }}
                </div>
              </div>
            }
            @if (i === 4) {
              <div class="item-cell">
                {{element[column] | dateTimeFormatPipe: 'dmyt':tz.selectedOption}}
              </div>
            }
            @if (i === 5) {
              <div class="item-cell">
                {{element[column] | dateTimeFormatPipe: 'dmyt':tz.selectedOption}}
              </div>
            }
            @if (i === 6) {
              <div class="item-cell"  [matTooltip]="element[column]| shortDuration" >
                {{element[column] | duration:true:'seconds'}}
              </div>
            }
            @if (i === 7) {
              <div class="item-cell text-nowrap">
                {{element[column] | number: '1.2-2' | customNumberFormat }} kWh
              </div>
            }
            @if (i === 8) {
              <div class="item-cell text-nowrap">
                {{element[column] | number: '1.2-2' | customNumberFormat }} {{ ''|currencyPortfolio }}
              </div>
            }
            @if (i === 9) {
              <div class="item-cell">
                {{element[column] | dateTimeFormatPipe: 'dmyt':tz.selectedOption}}
              </div>
            }
            @if (i === 10) {
              <div >
                @if (!isProcessUnassigning) {
                  <lib-select
                    id="kpi-planned-events-list-table-select-option"
                    [options]="optionsSelect"
                    [classes]="'text-primary text-left font-size-normal'"
                    [withIcon]="true"
                    [fullWidth]="true"
                    [placement]="isLastRow ? 'top-right' : 'bottom-right'"
                    [showCaret]="false"
                    [inactiveOptionClasses]="''"
                    (selectedChanged)="selectOption($event, element)">
                    <ng-container icon>
                      <i class="far fa-ellipsis-h font-icons pointer bg-transparent"></i>
                    </ng-container>
                  </lib-select>
                }
              </div>
            }
          </td>
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplay" class="example-element-row"></tr>
    </table>
  </div>
}

